export default {
    methods: {
        async setGarniture(ProductId) {
            if (
                this.product.garniture.set_article &&
                this.product.garniture.set_id
            ) {
                //Добавляем изделия в существующий гарнитур
                let data = {
                    SetID: this.product.garniture.set_id,
                    Items: [ProductId]
                }

                await this.setItemsToSet(data)
            } else if (this.product.garniture.set_article) {
                //создаем новый гарнитур с изделиями

                let data = {
                    BrandID: this.product.brand,
                    SetArticle: this.product.garniture.set_article,
                    Items: [ProductId]
                }

                await this.createSet(data)
            } else if (
                !this.product.garniture.set_article &&
                this.product.garnitureSavedId
            ) {
                //удаляем гарнитуру
                let data = {
                    SetID: this.product.garnitureSavedId,
                    Items: [ProductId]
                }
                await this.removeItemsFromSet(data)
            }

            if (
                Object.keys(this.supplierSetsErrors.setItemsToSet).length ||
                Object.keys(this.supplierSetsErrors.createSet).length
            ) {
                this.$notify({
                    type: 'error',
                    text: 'Ошибка при добавлении в гарнитур'
                })
            }
        }
    }
}
